import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import style from './pagination.module.scss';

const Pagination = ({
  currentPage,
  totalPages,
  totalResults = null,
  onPageChange,
  loading = false,
}) => {
  const rootRef = useRef(null);

  // Posle promene stranice, glatko skroluj na vrh tabele (radi i kada tabela
  // ima svoj scroll kontejner, i kada skroluje cela stranica).
  const scrollToTableTop = () => {
    const table = rootRef.current?.parentElement?.querySelector('table');
    if (table && typeof table.scrollIntoView === 'function') {
      table.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePrevious = () => {
    if (!loading && currentPage > 1) {
      onPageChange(currentPage - 1);
      scrollToTableTop();
    }
  };

  const handleNext = () => {
    if (!loading && currentPage < totalPages) {
      onPageChange(currentPage + 1);
      scrollToTableTop();
    }
  };

  return (
    <div className={style.pagination} ref={rootRef}>
      <div className={style.pagination__buttons}>
        <Button
          disabled={loading || currentPage === 1}
          onClick={handlePrevious}
        >
          Prethodna
        </Button>
        <Button
          className={style.pagination__nextButton}
          disabled={loading || currentPage === totalPages || totalPages === 0}
          onClick={handleNext}
        >
          Sledeća
        </Button>
      </div>
      <div className={style.pagination__count}>
        <p>
          Stranica {currentPage} od {totalPages === 0 ? 1 : totalPages}
          {typeof totalResults === 'number' ? ` (${totalResults} rezultata)` : ''}
        </p>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalResults: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default Pagination;
